/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Me,
  Version
} from '../model';

import { apiFetch } from '../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getUserMeUrl = () => {




  return `/api/v1/me`
}

/**
 * @summary The logged-in user and their roles
 */
export const userMe = async ( options?: Parameters<typeof apiFetch>[1]): Promise<Me> => {

  return apiFetch<Me>(getUserMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUserMeQueryKey = () => {
    return [
    `/api/v1/me`
    ] as const;
    }


export const getUserMeQueryOptions = <TData = Awaited<ReturnType<typeof userMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userMe>>> = ({ signal }) => userMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserMeQueryResult = NonNullable<Awaited<ReturnType<typeof userMe>>>
export type UserMeQueryError = unknown


export function useUserMe<TData = Awaited<ReturnType<typeof userMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userMe>>,
          TError,
          Awaited<ReturnType<typeof userMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserMe<TData = Awaited<ReturnType<typeof userMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userMe>>,
          TError,
          Awaited<ReturnType<typeof userMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserMe<TData = Awaited<ReturnType<typeof userMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The logged-in user and their roles
 */

export function useUserMe<TData = Awaited<ReturnType<typeof userMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUserVersionUrl = () => {




  return `/api/v1/version`
}

/**
 * @summary Application name, semantic version and environment (public)
 */
export const userVersion = async ( options?: Parameters<typeof apiFetch>[1]): Promise<Version> => {

  return apiFetch<Version>(getUserVersionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUserVersionQueryKey = () => {
    return [
    `/api/v1/version`
    ] as const;
    }


export const getUserVersionQueryOptions = <TData = Awaited<ReturnType<typeof userVersion>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVersion>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userVersion>>> = ({ signal }) => userVersion({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserVersionQueryResult = NonNullable<Awaited<ReturnType<typeof userVersion>>>
export type UserVersionQueryError = unknown


export function useUserVersion<TData = Awaited<ReturnType<typeof userVersion>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userVersion>>,
          TError,
          Awaited<ReturnType<typeof userVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserVersion<TData = Awaited<ReturnType<typeof userVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userVersion>>,
          TError,
          Awaited<ReturnType<typeof userVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserVersion<TData = Awaited<ReturnType<typeof userVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVersion>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Application name, semantic version and environment (public)
 */

export function useUserVersion<TData = Awaited<ReturnType<typeof userVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVersion>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






